<nav class="px-3 navbar navbar-expand-lg bg-light navbar-dark d-flex justify-content-between align-items-center">
  <img src="assets/logo/momma.png" alt="Logo" style="width: 230px;"/>
  <div class="d-flex align-items-center">
      <button class="btn btn-success mx-2" (click)="switchLanguage()">
        <i class="bi bi-translate"></i>
      </button>
      <button class="btn btn-danger mx-2" (click)="logout()">
        <i class="bi bi-box-arrow-left"></i>
      </button>
  </div>
</nav>